module.exports = __webpack_public_path__ + "images/bot1b632d4760a356db894db7e42a48f8869.svg";